export default __webpack_public_path__ + "static/media/str3.44a6ada6.svg";